export const MENU_CSS_CLASSES = {
    parent: 'parent',
    submenu: 'submenu',
    opened: 'opened',
    level1: 'level1'
} as const;

export const MENU_SELECTORS = {
    linkInsideMenuItem: 'li > h3 > a[role="menuitem"]'
} as const;
